import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  useEffect(() => {
    document.title = 'Polityka Prywatności | VROOM.APP';
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page-card">
        <div className="legal-header">
          <h2>POLITYKA <span>PRYWATNOŚCI</span></h2>
        </div>

        <div className="legal-body legal-body-standalone">
          <p className="legal-date">Ostatnia aktualizacja: 11 maja 2026</p>

          <div className="legal-section">
            <h3>§1 Administrator danych</h3>
            <p>
              Administratorem danych jest zespół VROOM.
              Kontakt: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a>
            </p>
          </div>

          <div className="legal-section">
            <h3>§2 Jakie dane zbieramy</h3>
            <ul>
              <li><strong>Dane rejestracyjne:</strong> e-mail, nazwa użytkownika, hasło (zaszyfrowane)</li>
              <li><strong>Dane aktywności:</strong> kilometry, odwiedzone miasta, osiągnięcia</li>
              <li><strong>Treści użytkownika:</strong> zdjęcia spotów, komentarze, dane garażu</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>§3 Dane o lokalizacji urządzenia (LOCATION / GPS)</h3>
            <p>
              <strong>Location data disclosure (English):</strong> The VROOM mobile application accesses
              location data from your device (including precise GPS coordinates when you grant permission).
              This includes location used in the foreground and, if you enable the relevant options in the
              app or system settings, location collected while the app runs in the background for driving
              statistics and similar features.
            </p>
            <p>
              <strong>Ujawnienie (PL):</strong> Aplikacja mobilna VROOM uzyskuje dostęp do danych o
              lokalizacji urządzenia (w tym <strong>współrzędnych GPS</strong> — lokalizacji
              <strong> dokładnej / precyzyjnej</strong>) po uzyskaniu uprawnień w systemie operacyjnym
              (Android / iOS) oraz — w zakresie wybranych funkcji — po włączeniu opcji w samej aplikacji.
            </p>
            <ul>
              <li>
                <strong>Mapa i nawigacja:</strong> pozycja na mapie, wyznaczanie i podążanie trasą,
                dopasowanie do drogi (snap), odczyty prędkości z sensorów urządzenia tam, gdzie system je udostępnia.
              </li>
              <li>
                <strong>Tryb jazdy / statystyki trasy:</strong> zapis przejazdu, dystans, elementy trasy
                w celu statystyk i historii aktywności — także gdy włączone jest śledzenie w tle zgodnie z
                ustawieniami aplikacji i uprawnieniami systemu.
              </li>
              <li>
                <strong>Udostępnianie pozycji (Live Map):</strong> po włączeniu funkcji współrzędne mogą być
                przesyłane na serwery Operatora i udostępniane innym użytkownikom zgodnie z działaniem funkcji.
              </li>
              <li>
                <strong>Dostawcy map i usług geolokalizacyjnych:</strong> część żądań (np. mapy, wyznaczanie
                trasy, dopasowanie do sieci dróg) jest obsługiwana przez zewnętrznych dostawców (np. Mapbox)
                — przekazywane są im ograniczone dane potrzebne do realizacji żądania (np. fragmenty trasy /
                współrzędne), zgodnie z ich regulaminami.
              </li>
              <li>
                <strong>Brak zgody / cofnięcie zgody:</strong> możesz cofnąć dostęp do lokalizacji w ustawieniach
                systemu lub ograniczyć funkcje w aplikacji — wtedy część funkcji może być niedostępna.
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>§4 Cel przetwarzania danych</h3>
            <ul>
              <li>Świadczenie usług aplikacji (nawigacja, Live Map, rankingi)</li>
              <li>Bezpieczeństwo systemu i zapobieganie nadużyciom</li>
              <li>Obsługa konta i funkcji społecznościowych</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>§5 Podstawa prawna (RODO)</h3>
            <ul>
              <li>Art. 6 ust. 1 lit. b — wykonanie umowy</li>
              <li>Art. 6 ust. 1 lit. a — zgoda użytkownika</li>
              <li>Art. 6 ust. 1 lit. f — uzasadniony interes administratora</li>
            </ul>
          </div>

          <div className="legal-section">
            <h3>§6 Prawa użytkownika</h3>
            <ul>
              <li>Dostęp do danych, sprostowanie i usunięcie danych</li>
              <li>Ograniczenie przetwarzania i przenoszenie danych</li>
              <li>Wniesienie skargi do Prezesa UODO</li>
            </ul>
            <p>
              Żądania dotyczące danych: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a>
            </p>
          </div>

          <div className="legal-section">
            <h3>§7 Retencja i bezpieczeństwo</h3>
            <p>Dane przechowywane są przez czas aktywności konta. Po usunięciu konta dane są usuwane w ciągu 30 dni.</p>
            <p>Komunikacja jest zabezpieczona przez HTTPS, a hasła są przechowywane w postaci hashy (bcrypt).</p>
          </div>

          <div className="legal-section">
            <h3>§8 Kontakt</h3>
            <p>W sprawach prywatności i danych osobowych: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a></p>
          </div>
        </div>

        <div className="legal-page-footer">
          <Link to="/" className="legal-page-link">Wróć na stronę główną</Link>
        </div>
      </div>
    </div>
  );
}

